import { create } from 'zustand';
import { Step } from 'react-joyride';
import { Reservation } from '../apis/models/reservations/res/Reservation';

export const MIMO_TUT_EVENT = 'MIMO_TUTORIAL_EVENT';

export type ReservationTutorialEventType =
  | 'TREATMENT_SELECTED' // 1. 시술 선택 완료
  | 'RESERVE_BUTTON_CLICKED' // 2. 예약하기 버튼 클릭
  | 'DATETIME_SELECTED' // 3. 날짜 및 시간 클릭
  | 'RESERVATION_COMPLETED' // 4. 예약 완료
  | 'TUTORIAL_END'; // 5. 튜토리얼 종료

interface ReservationTutorialMessage {
  type: 'MIMO_TUTORIAL_EVENT';
  event: ReservationTutorialEventType;
  payload?: any;
}

export const sendTutorialEndEvent = () => {
  if (window.parent) {
    const tutorialMessage: ReservationTutorialMessage = {
      type: MIMO_TUT_EVENT,
      event: 'TUTORIAL_END',
    };
    window.parent.postMessage(tutorialMessage, '*');
  }
};

export const sendTutorialTreatmentSelectedEvent = () => {
  if (window.parent) {
    const tutorialMessage: ReservationTutorialMessage = {
      type: MIMO_TUT_EVENT,
      event: 'RESERVE_BUTTON_CLICKED',
    };
    window.parent.postMessage(tutorialMessage, '*');
  }
};

export const sendTutorialReservationDateSelectedEvent = () => {
  if (window.parent) {
    const tutorialMessage: ReservationTutorialMessage = {
      type: MIMO_TUT_EVENT,
      event: 'DATETIME_SELECTED',
    };
    window.parent.postMessage(tutorialMessage, '*');
  }
};

export const sendTutorialReservationCompleteEvent = (
  reservation: Reservation,
) => {
  if (window.parent) {
    const tutorialMessage: ReservationTutorialMessage = {
      type: MIMO_TUT_EVENT,
      event: 'RESERVATION_COMPLETED',
      payload: reservation,
    };
    window.parent.postMessage(tutorialMessage, '*');
  }
};

export const tutorialSteps: Step[] = [
  {
    target: '.tutorial-product',
    content: '',
    disableBeacon: true,
  },
  {
    target: '#tutorial-next1',
    content: '',
    disableBeacon: true,
  },
  {
    target: '#tutorial-date-select',
    content: '',
    disableBeacon: true,
  },
  {
    target: '#tutorial-date-select-next',
    content: '',
    disableBeacon: true,
  },
  {
    target: '#tutorial-reservation-button',
    content: '',
    disableBeacon: true,
  },
];

type TutorialStore = {
  stepIndex: number;
  run: boolean;
  steps: typeof tutorialSteps;
  nextStep: () => void;
  reset: () => void;
  start: () => void;
  stop: () => void;
};

export const useTutorialStore = create<TutorialStore>((set) => ({
  stepIndex: 0,
  run: false,
  steps: tutorialSteps,
  nextStep: () => set((state) => ({ stepIndex: state.stepIndex + 1 })),
  reset: () => set(() => ({ stepIndex: 0, run: true })),
  start: () => set(() => ({ run: true })),
  stop: () => set(() => ({ run: false })),
}));
